export const changeOrganizationMembersRoleBulkActionType = 'changeOrganizationMembersRole';
